import { __rest } from "tslib";
import React from 'react';
import { Switch } from 'antd';
import classnames from 'classnames';
import './siriusSwitch.scss';
export const prefixCls = 'sirius-switch';
const SiriusSwitch = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement(Switch, Object.assign({ className: classnames(prefixCls, className) }, props, { ref: ref }));
});
export default SiriusSwitch;
